import React from 'react'

function IconBoxService14({ fill, stroke }) {
  return (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1.38892 13V7V5C1.38892 2.79086 3.17978 1 5.38892 1H7.38892H13.3889V7V9C13.3889 11.2091 11.5981 13 9.38892 13H7.38892H1.38892Z" fill={fill} />
      <path d="M7.38892 1H5.38892C3.17978 1 1.38892 2.79086 1.38892 5V7M7.38892 1H13.3889V7M7.38892 1V13M1.38892 7V13H7.38892M1.38892 7H13.3889M13.3889 7V9C13.3889 11.2091 11.5981 13 9.38892 13H7.38892" stroke={stroke} />
    </svg>
  )
}

export default IconBoxService14